import { GetStaticPathsResult, GetStaticPropsContext, GetStaticPropsResult } from 'next';

import { getKnot } from '../../src/api/contentful/getKnot';
import { getKnots } from '../../src/api/contentful/getKnots';
import { NOT_FOUND_WITH_REVALIDATION, REVALIDATE } from '../../src/constants/next';
import { reportMykissClientError } from '../../src/helpers/errorHandling/client';
import { IPageMetadata } from '../../src/interfaces/nextjs';
import { IKnotProps, Knot } from '../../src/views/Knot/Knot';

type IParams = {
  slug: string;
};

export async function getStaticProps({
  params,
}: GetStaticPropsContext<IParams>): Promise<GetStaticPropsResult<IPageMetadata & IKnotProps>> {
  const knotSlug = params?.slug;
  if (!knotSlug) {
    return { notFound: true };
  }

  try {
    const knot = await getKnot(knotSlug);

    return {
      props: {
        _page: 'knot',
        _pageTitle: 'Knot',
        knot,
      },
      revalidate: REVALIDATE.DAILY,
    };
  } catch (error) {
    reportMykissClientError(error);
    return NOT_FOUND_WITH_REVALIDATION;
  }
}

export async function getStaticPaths(): Promise<GetStaticPathsResult<IParams>> {
  const knotsCollection = await getKnots();
  const slugs = knotsCollection.items.map(i => i.fields.slug || '').filter(slug => slug !== '');

  return {
    paths: slugs.map(slug => ({ params: { slug } })),
    fallback: false,
  };
}

export default Knot;
